import { isEmpty } from "./isEmpty";

export const convertTimestampToDayAndMonth = (data) => {
    // Criar um novo objeto com as datas formatadas como "dd/mm"
    const formattedObject = {};

    if (data && !isEmpty(data)) {
        // Ordenar as chaves (timestamps) em ordem crescente
        const sortedTimestamps = Object.keys(data).sort((a, b) => a - b);

        sortedTimestamps.forEach(timestamp => {
            // Converter o timestamp Unix (em segundos) para milissegundos
            const date = new Date(parseInt(timestamp) * 1000);

            // Obter o dia e o mês
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero

            // Formatar a data como "dd/mm"
            const formattedDate = `${day}/${month}`;

            // Adicionar ao novo objeto
            formattedObject[formattedDate] = data[timestamp];
        });
    }
    return formattedObject;
};

export const convertTimestampToDayAndMonthAndYear = (data) => {
    // Criar um novo objeto com as datas formatadas como "dd/mm"
    const formattedObject = {};

    if (data && !isEmpty(data)) {
        // Ordenar as chaves (timestamps) em ordem crescente
        const sortedTimestamps = Object.keys(data).sort((a, b) => a - b);

        sortedTimestamps.forEach(timestamp => {
            // Converter o timestamp Unix (em segundos) para milissegundos
            const date = new Date(parseInt(timestamp) * 1000);

            // Obter o dia e o mês
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Meses começam do zero
            const year = date.getFullYear();

            // Formatar a data como "dd/mm"
            const formattedDate = `${day}/${month}/${year}`;

            // Adicionar ao novo objeto
            formattedObject[formattedDate] = data[timestamp];
        });
    }
    return formattedObject;
};

export const convertTimestampToMonthLong = (data) => {
    const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

    // Criar um novo objeto para armazenar os valores organizados
    const formattedObject = {};

    if (data && Object.keys(data).length > 0) {
        Object.keys(data).forEach(timestamp => {
            // Converter o timestamp Unix (em segundos) para milissegundos
            const date = new Date(parseInt(timestamp) * 1000);

            // Obter o mês (meses começam do zero)
            const month = date.getMonth();

            // Usar o nome do mês correspondente
            const formattedDate = `${months[month]}`;

            // Adicionar o valor no mês correspondente
            formattedObject[formattedDate] = data[timestamp];
        });
    }

    // Garantir que todos os meses estão no objeto, mesmo que ausentes
    return months.reduce((obj, month) => {
        // Se o mês existe no objeto, adicionar o valor ou null se não existir
        obj[month] = formattedObject[month] !== undefined ? formattedObject[month] : null;
        return obj;
    }, {});
};